"use strict";

$(document).ready(function () {
  if ($('body#contact').length > 0) {
    tabsInner();
  }
});

function tabsInner() {
  var tab = $('.tabs-container .tabs .tab');
  tab.on('click', function () {
    if ($(this).hasClass('active')) {
      return;
    } else {
      $(this).addClass('active');
      $(this).siblings().removeClass('active');
      var targetId = $(this).data('tab');
      var target = $(".tabs-wrapper, main").find("[data-tab-container*='" + targetId + "']");
      target.siblings().removeClass('active');
      target.removeClass('active');
      setTimeout(function () {
        target.siblings().addClass('none');
        target.addClass('none');
        target.removeClass('none');

        if (targetId === 'all') {
          $('.tabs-wrapper .content-container').addClass('all-active');
        } else {
          $('.tabs-wrapper .content-container').removeClass('all-active');
        }
      }, 300);
      target.addClass('active');
    }
  });
}